import React, { useMemo } from 'react';
import { fmt, MES_LABEL, esVenta, esCompra } from './constants';

function Card({ label, value, icon, color, sub, onClick }) {
  return (
    <div onClick={onClick} style={{
      background:'var(--card)',border:'1px solid var(--border)',
      borderLeft:`3px solid ${color}`,borderRadius:'var(--radius)',
      padding:'1rem 1.15rem',cursor:onClick?'pointer':undefined,
      transition:'transform 0.15s',
    }}
    onMouseEnter={e=>onClick&&(e.currentTarget.style.transform='translateY(-2px)')}
    onMouseLeave={e=>onClick&&(e.currentTarget.style.transform='')}>
      <div style={{display:'flex',alignItems:'center',gap:8,marginBottom:8}}>
        <div style={{width:30,height:30,borderRadius:'var(--radius-sm)',background:`${color}1a`,display:'flex',alignItems:'center',justifyContent:'center'}}>
          <i className={`ti ${icon}`} style={{fontSize:15,color}} />
        </div>
        <span style={{fontSize:11,color:'var(--text2)'}}>{label}</span>
      </div>
      <div style={{fontSize:20,fontWeight:700,color}}>{value}</div>
      {sub && <div style={{fontSize:11,color:'var(--text3)',marginTop:3}}>{sub}</div>}
    </div>
  );
}

export default function Dashboard({ movimientos, onTab }) {
  const stats = useMemo(()=>{
    const ventas  = movimientos.filter(esVenta);
    const compras = movimientos.filter(esCompra);
    const vNeta   = ventas.reduce((a,m)=>a+m.monto,0);
    const cNeta   = compras.reduce((a,m)=>a+m.monto,0);
    const ivaVta  = ventas.filter(m=>m.subTipo==='facturada').reduce((a,m)=>a+(m.monto_iva||0),0);
    const ivaCmp  = compras.reduce((a,m)=>a+(m.monto_iva||0),0);
    const sfVenta = ventas.filter(m=>m.subTipo==='sin_factura').reduce((a,m)=>a+m.monto,0);
    return { vNeta, cNeta, resultado:vNeta-cNeta, ivaVta, ivaCmp, ivaNeto:ivaVta-ivaCmp, sfVenta, nVentas:ventas.length, nCompras:compras.length };
  },[movimientos]);

  const mesesChart = useMemo(()=>
    [...new Set(movimientos.map(m=>m.fecha.slice(0,7)))].sort().slice(-8)
  ,[movimientos]);

  const maxBar = useMemo(()=>Math.max(...mesesChart.map(mes=>{
    const v=movimientos.filter(m=>esVenta(m)&&m.fecha.startsWith(mes)).reduce((a,m)=>a+m.monto,0);
    const c=movimientos.filter(m=>esCompra(m)&&m.fecha.startsWith(mes)).reduce((a,m)=>a+m.monto,0);
    return Math.max(v,c);
  }),1),[movimientos,mesesChart]);

  const recientes = useMemo(()=>
    [...movimientos].sort((a,b)=>b.fecha.localeCompare(a.fecha)).slice(0,8)
  ,[movimientos]);

  if (movimientos.length===0) return (
    <div style={{textAlign:'center',padding:'4rem',color:'var(--text3)'}}>
      <i className="ti ti-report-money" style={{fontSize:52,display:'block',marginBottom:14}} />
      <p style={{fontSize:16,marginBottom:8,color:'var(--text2)'}}>Bienvenido a Contabilidad Inmaluca</p>
      <p style={{fontSize:13}}>Usa <b>"Cargar datos"</b> en el menú lateral para importar los datos de COMERCIAL.xlsx</p>
    </div>
  );

  return (
    <div>
      <h2 style={{fontSize:15,fontWeight:700,marginBottom:16}}>
        <i className="ti ti-layout-dashboard" style={{marginRight:8,color:'var(--blue)'}} />Dashboard
      </h2>

      <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fit,minmax(150px,1fr))',gap:10,marginBottom:18}}>
        <Card label="Ventas Netas"    value={fmt(stats.vNeta)}    icon="ti-arrow-up-circle" color="#10b981" sub={`${stats.nVentas} registros`}  onClick={()=>onTab('libro_ventas')} />
        <Card label="Compras Netas"   value={fmt(stats.cNeta)}    icon="ti-shopping-cart"   color="#ef4444" sub={`${stats.nCompras} registros`} onClick={()=>onTab('libro_compras')} />
        <Card label="Resultado Neto"  value={fmt(stats.resultado)} icon="ti-scale"           color={stats.resultado>=0?'#10b981':'#ef4444'} />
        <Card label="IVA Neto (F29)"  value={fmt(stats.ivaNeto)}  icon="ti-percentage"      color="#3b82f6" sub={stats.ivaNeto>0?'Por pagar SII':'Crédito a favor'} onClick={()=>onTab('iva')} />
        <Card label="Ventas S/F"      value={fmt(stats.sfVenta)}  icon="ti-file-off"        color="#f59e0b" sub="Ago–Oct 2025 (sin factura)" />
      </div>

      {/* Gráfico */}
      <div style={{background:'var(--card)',border:'1px solid var(--border)',borderRadius:'var(--radius)',padding:'1.25rem',marginBottom:18}}>
        <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:12}}>
          <p style={{fontWeight:600,fontSize:13}}><i className="ti ti-chart-bar" style={{marginRight:7,color:'var(--blue)'}} />Evolución mensual</p>
          <div style={{display:'flex',gap:14}}>
            {[['#10b981','Ventas'],['#ef4444','Compras']].map(([c,l])=>(
              <span key={l} style={{fontSize:11,color:'var(--text2)',display:'flex',alignItems:'center',gap:5}}>
                <span style={{width:10,height:10,borderRadius:2,background:c,display:'inline-block'}} />{l}
              </span>
            ))}
          </div>
        </div>
        <div style={{display:'flex',alignItems:'flex-end',gap:6,height:130,overflowX:'auto'}}>
          {mesesChart.map(mes=>{
            const v=movimientos.filter(m=>esVenta(m)&&m.fecha.startsWith(mes)).reduce((a,m)=>a+m.monto,0);
            const c=movimientos.filter(m=>esCompra(m)&&m.fecha.startsWith(mes)).reduce((a,m)=>a+m.monto,0);
            return (
              <div key={mes} style={{flex:1,minWidth:44,display:'flex',flexDirection:'column',alignItems:'center',gap:4}}>
                <div style={{width:'100%',display:'flex',gap:2,alignItems:'flex-end',height:100}}>
                  <div title={`Ventas: ${fmt(v)}`} style={{flex:1,background:'#10b981',borderRadius:'4px 4px 0 0',height:Math.max(Math.round((v/maxBar)*100),2)}} />
                  <div title={`Compras: ${fmt(c)}`} style={{flex:1,background:'#ef4444',borderRadius:'4px 4px 0 0',height:Math.max(Math.round((c/maxBar)*100),2)}} />
                </div>
                <span style={{fontSize:10,color:'var(--text3)',whiteSpace:'nowrap'}}>{MES_LABEL(mes)}</span>
              </div>
            );
          })}
        </div>
      </div>

      {/* Últimos movimientos */}
      <div style={{background:'var(--card)',border:'1px solid var(--border)',borderRadius:'var(--radius)',padding:'1.25rem'}}>
        <p style={{fontWeight:600,fontSize:13,marginBottom:12}}><i className="ti ti-history" style={{marginRight:7,color:'var(--purple)'}} />Últimos movimientos</p>
        {recientes.map(m=>{
          const isV=esVenta(m); const color=isV?'#10b981':'#ef4444';
          return (
            <div key={m.id} style={{display:'flex',alignItems:'center',gap:10,padding:'8px 0',borderBottom:'1px solid var(--border)'}}>
              <div style={{width:32,height:32,borderRadius:'var(--radius-sm)',background:`${color}1a`,display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0}}>
                <i className={`ti ${isV?'ti-arrow-up-circle':'ti-arrow-down-circle'}`} style={{fontSize:15,color}} />
              </div>
              <div style={{flex:1,minWidth:0}}>
                <p style={{fontSize:12,fontWeight:500,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{m.descripcion||m.categoria}</p>
                <p style={{fontSize:11,color:'var(--text3)'}}>{m.razonSocial||m.categoria} · {m.fecha}</p>
              </div>
              <p style={{fontWeight:700,fontSize:13,color,flexShrink:0}}>{isV?'+':'-'}{fmt(m.monto)}</p>
            </div>
          );
        })}
      </div>
    </div>
  );
}
